/**
 * Product template - Show text of selected color/size
 */
window.addEventListener('load', frd_product_swatches);

function frd_product_swatches() {
  if (typeof frd_product === 'undefined') {
    return;
  }
  const frd_pdp_product_handle = frd_product.handle;
  let frd_pdp_variant_id = frd_product.default_variant_id;
  const frd_pdp_variant_title = document.querySelector('.selected-color-name span');
  const frd_pdp_variant_swatches = document.querySelectorAll('.latest-variant-option .latest-option');

  // Update variant title
  frd_pdp_variant_title.innerText = frd_product.default_variant_title;

  // Loop variants
  frd_pdp_variant_swatches.forEach((frd_pdp_variant_swatch, index) => {
    // Add listener to each variant
    frd_pdp_variant_swatch.addEventListener('click', (event) => {
      // Get variant data
      fetch('/products/' + frd_pdp_product_handle + '.js').then(function(response) {
        return response.json();
      }).then(function(product) {
        const url_parameters = new URLSearchParams(window.location.search);
        frd_pdp_variant_id = parseInt(url_parameters.get('variant'));
        let frd_pdp_variant = product.variants.find(function(variant){ return variant.id === frd_pdp_variant_id });

        if(frd_pdp_variant) {
          let frd_pdp_variant_title_text = frd_pdp_variant.title;
  
          // Update variant title
          frd_pdp_variant_title.innerHTML =  frd_pdp_variant_title_text;
        }
      });
    });
  });
}
